import { $, $$ } from './lib/selectors';

import initActions from './components/action';
import initNav from './components/nav';
import initVideo from './components/video';

import { createPopper } from '@popperjs/core';

initActions();
initNav();
initVideo();

$$('.js-glossary').forEach(glossaryEl => {
  const popupEl = $(glossaryEl, '.js-glossary__popup');
  createPopper(glossaryEl, popupEl, {placement: 'top', offset: [0, 10]});
});

// Forward URL params around the site for AK mailing tracking
$$('a').forEach(anchorEl => {
  if (anchorEl.href.indexOf(siteConfig.siteUrl) > -1 && anchorEl.href.indexOf(location.search) === -1) {
    const hrefParts = anchorEl.href.split('#');
    const newHref = hrefParts[0] + location.search + (hrefParts[1] ? '#' + hrefParts[1] : '');
    anchorEl.addEventListener('click', function (evt) {
      evt.preventDefault();
      window.location = newHref;
    });
  }
});
